var map = {
	"./de/requirements_descriptions": [
		"e4zJ",
		49
	],
	"./en/requirements_descriptions": [
		"HLtA",
		33
	],
	"./fr/requirements_descriptions": [
		"Xmlg",
		17
	],
	"./nl/requirements_descriptions": [
		"ze+5",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "RQPD";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/requirements_descriptions$
// module id = RQPD
// module chunks = 97